<template>
  <li
    class="w-full relative"
    :class="{
      'pb-3': isOpen
    }"
  >
    <a
      :href="item.url"
      class="menu-item w-full px-4 py-1 flex items-center justify-between"
      :class="{ 'text-gray-600': level >= 3 }"
      :target="item.target === '' ? '_self' : item.target"
      @click="handleClick"
    >
      {{ item.title }}
      <span
        v-if="item.children && item.children.length"
        aria-hidden="true"
        class="ml-4 shrink-0 w-6 h-6 rotate-transition rotate-90"
        :class="{ 'rotate-arrow': isOpen }"
      />
    </a>
    <Transition>
      <ul v-if="item.children && item.children.length && isOpen">
        <MobileMenuItem
          :class="{
            'pl-12 ': level === 1,
            'pl-6 text-gray-500': level >= 2
          }"
          v-for="(child, index) in item.children"
          :key="index"
          :item="child"
          :level="level + 1"
          @close="closeMenu"
        />
      </ul>
    </Transition>
  </li>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface MenuItem {
  title: string
  url: string
  target: string
  children?: MenuItem[]
}

const props = defineProps<{
  item: MenuItem
  level?: number
}>()

const emit = defineEmits(['close'])

const isOpen = ref(false)

const closeMenu = () => {
  emit('close')
}

const level = props.level ?? 0

const handleClick = (event: MouseEvent) => {
  if (props.item.children && props.item.children.length > 0) {
    event.preventDefault()
    isOpen.value = !isOpen.value
  } else {
    closeMenu()
  }
}
</script>

<style lang="css" scoped>
.rotate-transition {
  transition: transform 0.3s ease;
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='currentColor'%3E%3Cpath d='M472-480 288-664l88-88 272 272-272 272-88-88 184-184Z'/%3E%3C/svg%3E");
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: currentColor;
}

.rotate-arrow {
  transform: rotate(180deg);
}
</style>
